import * as React from 'react';
import dayjs from 'dayjs';
import TextField from '@mui/material/TextField';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';
import { useState } from 'react';
import { useEffect } from 'react';
import { Button } from '@mui/material';
import colors from '../../../utils/colors';
import { makeStyles } from '@mui/styles';

const OKButton = {
  borderRadius: 40,
  padding: '8px 6px',
  cursor: 'pointer',
  fontWeight: 400,
  '& .MuiButton-label': {
    color: colors.WHITE,
    fontFamily: 'Inter',
    fontSize: '16px',
    width: 'fit-content',
  },
};

const useStyles = makeStyles(() => ({
  pickerRoot: {
    '& .Mui-selected': {
      backgroundColor: '#036FCB!important',
    },
  },
}));

const CustomStaticDatePicker = React.forwardRef((props, ref) => {
  const [value, setValue] = useState();
  const classes = useStyles();
  useEffect(() => {
    setValue(dayjs(props?.customDate));
  }, [props?.customDate]);

  const handleOnClick = () => {
    if (value) {
      props?.handleDateSelect(value);
      ref.current.style.display = 'none';
    }
  };

  return (
    <div
      className={props.rootClass}
      style={{ display: 'none', border: '1px solid rgba(3, 111, 203, 0.08)' }}
      ref={ref}
    >
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <StaticDatePicker
          displayStaticWrapperAs="desktop"
          disableFuture={true}
          disableHighlightToday={true}
          openTo="day"
          value={value}
          onChange={(newValue)=>{            
            setValue(newValue);
          }}
          autoOk={false}
          closeOnSelect={false}
          className={classes.pickerRoot}
          renderInput={(params) => <TextField {...params} />}
        />
      </LocalizationProvider>
      <div style={{ position: 'absolute', bottom: '8px', right: '30px' }}>
        <Button color="secondary" variant="contained" sx={OKButton} onClick={handleOnClick}>
          OK
        </Button>
      </div>
    </div>
  );
});

export default CustomStaticDatePicker;
